module.exports = __webpack_public_path__ + "img/home-arc.add60649.jpg";